import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import Form from "./email form component/Form";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5cce200;
  height: 100%;
  padding: 0 30px;
`;

export default function ResetPassword() {
  return (
    <Wrapper>
      <Helmet title="Forgot Password" />
      <Form />
    </Wrapper>
  );
}
